import { StyleSheet, type ViewStyle } from 'react-native';

export const layeredAvatarViewStyles = StyleSheet.create({
  layer: {
    ...StyleSheet.absoluteFillObject,
    width: '100%',
    height: '100%',
  },
});

/** Square box sized to `size`; circular crop when rounded. */
export function getLayeredAvatarBoxStyle(size: number, rounded: boolean): ViewStyle {
  return {
    width: size,
    height: size,
    position: 'relative',
    overflow: 'hidden',
    borderRadius: rounded ? size / 2 : 0,
  };
}
